module.exports = __webpack_public_path__ + "static/media/fabric.cb4d75d5.jpg";